import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReactSession } from "../../../lib/secure_reactsession";
import { LayoutResearcher } from "../../themes/userq/Layouts/layout_researcher";
import { Text } from "../../themes/userq/Text/Text";
import { LoadingIcon } from "../../themes/userq/Loader/loadingIcon";
import { Button } from "../../themes/userq/Button/Button";
import { Icon } from "../../themes/userq/Icon/Icon";
import { Preview } from "../../themes/userq/Preview/preview";
import { getPrototypeNodeScreensService } from "../../../services/test";
import { Helmet } from "react-helmet";
import { getPageTitle } from "../../../lib/pageTitle";

export default function PrototypeNodeScreens() {
    ReactSession.setStoreType("localStorage");

    const { test_id } = useParams();
    const navigate = useNavigate();

    const [tasks, setTasks] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [previewModal, setPreviewModal] = useState({ open: false, img: null });

    const token = ReactSession.get("token");

    useEffect(() => {
        if (!token) {
            navigate("/researcher/sign-in");
            return;
        }
        setLoading(true);
        getPrototypeNodeScreensService({ test_id }, token)
            .then((res) => {
                if (res && res.success) {
                    setTasks(res.data || []);
                } else {
                    setError("Failed to load prototype screens.");
                }
            })
            .catch(() => {
                setError("An error occurred while loading screens.");
            })
            .finally(() => {
                setLoading(false);
            });
    }, [test_id, navigate, token]);

    const resolveImageSrc = (screen) => {
        if (screen.is_downloaded) {
            return process.env.REACT_APP_IMG_URL + screen.image_path;
        }
        return screen.remote_path;
    };

    return (
        <LayoutResearcher
            isLoading={false}
            skipCheck={false}
            extendedFooter={false}
            activeMenu={"dashboard"}
            wrapClass={""}
        >
            <Helmet>
                <title>{getPageTitle("Prototype Node Screens")}</title>
            </Helmet>

            {isLoading ? (
                <div className="welcome-modal-loader mid-page-loader">
                    <div className="welcome-loader-inner mid-page-inner-loader">
                        <LoadingIcon />
                    </div>
                </div>
            ) : (
                <div className="das-hdsrch-hold">
                    <div className="page-heading-wrap page-heading-wrap d-flex align-items-center justify-content-between dashboard-page-heading">
                        <div className="test-publish-fee-header-left align-items-center d-flex test-dashboard-title-left">
                            <h1 className="heading h1">Prototype Screens</h1>
                        </div>
                    </div>

                    {error && (
                        <div className="no-participants-data">
                            <Text type="body-text-2" cssClasses={"red-color"}>
                                {error}
                            </Text>
                        </div>
                    )}

                    {!error && tasks.length === 0 && (
                        <div className="no-participants-data">
                            <Text type="body-text-2">
                                No prototype screens found for this test.
                            </Text>
                        </div>
                    )}

                    {!error &&
                        tasks.map((task) => (
                            <div key={task.task_id} className="all-test-listing-wrapper">
                                <div className="row">
                                    {task.screens &&
                                        task.screens.map((screen) => (
                                            <div className="col-lg-3 col-md-4 col-sm-6 mb-16" key={screen.id}>
                                                <div className="common-path-content" style={{ border: "1px solid var(--gray-400)", borderRadius: "10px", padding: "12px", width: "100%" }}>
                                                    <div className="proto-common-path-img-preview image-preview" style={{ height: "180px" }}>
                                                        <img
                                                            src={resolveImageSrc(screen)}
                                                            alt={screen.name}
                                                            onError={(e) => {
                                                                e.target.style.display = "none";
                                                            }}
                                                        />
                                                        <div className="prototype-preview-btn">
                                                            <Button
                                                                type={"primary"}
                                                                cssclass={"white-bg-btn"}
                                                                size="small"
                                                                iconLeft={
                                                                    <Icon
                                                                        size={"small"}
                                                                        value={"eye"}
                                                                        colorClass={"gray-900-svg"}
                                                                    />
                                                                }
                                                                label={"Preview"}
                                                                onClick={() => {
                                                                    setPreviewModal({
                                                                        open: true,
                                                                        img: resolveImageSrc(screen),
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="common-path-content-footer">
                                                        <Text type={"caption"}>{screen.name}</Text>
                                                        <Text type={"caption"} cssClasses={"light-dark-text"}>{screen.node_id}</Text>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        ))}
                </div>
            )}

            <Preview
                withMinimizeIcon={true}
                open={previewModal.open}
                loading={false}
                img={previewModal.img}
                close={() => {
                    setPreviewModal({ open: false, img: null });
                }}
            />
        </LayoutResearcher>
    );
}
